import { Suspense } from "react";
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ITDProvider, Spin } from "@inntechcorp/it-design";
import lazy from "@loadable/component";
import { SkeletonTheme } from "react-loading-skeleton";

import { darkTheme } from "Context/darkTheme";
import { PrivateSocketProvider } from "Context/PrivateSocketContext";
import { WebProvider } from "Context/WebContext";

import { LoadingDefaultHeight, SpinWrapper } from "Styles/global.styled";

import "@inntechcorp/it-design/dist/global.css";
import "react-loading-skeleton/dist/skeleton.css";

import "Styles/global.scss";
import "overlayscrollbars/overlayscrollbars.css";
import "Styles/itd/itd-accordion-styles.scss";
import "Styles/itd/itd-select-styles.scss";
import "Styles/itd/itd-textarea-filled-styles.scss";
import "Styles/itd/itd-input-filled-styles.scss";
import "Styles/itd/itd-input-solid-styles.scss";
import "Styles/itd/itd-input-dashed-styles.scss";
import "Styles/itd/itd-button-styles.scss";
import "Styles/itd/itd-notifications-styles.scss";
import "Styles/itd/itd-date-picker-styles.scss";
import "Styles/itd/itd-checkbox-styles.scss";
import "Styles/itd/itd-spin-styles.scss";
import "Styles/itd/itd-result-styles.scss";
import "Styles/itd/itd-switch-styles.scss";
import "Styles/itd/itd-modal-styles.scss";
import "Styles/itd/itd-form-styles.scss";
import "Styles/itd/itd-table-styles.scss";
import "Styles/itd/itd-radio-group-styles.scss";
import "Styles/itd/itd-status-styles.scss";
import "Styles/itd/itd-alert-styles.scss";
import "Styles/itd/itd-toastr-styles.scss";
import "Styles/itd/mobile.scss";
import { PopBottomSheetProvider } from "Utils/popbottomsheet";
import { PublicSocketProvider } from "Context/PublicSocketContext";

const App = lazy(() => import("Pages/app"));

function renderDOM() {

  const rootElement = document.getElementById("inn-tech");
  const root        = rootElement && ReactDOMClient.createRoot(rootElement);

  const suspense = (
    <LoadingDefaultHeight $minHeight="100vh">
      <SpinWrapper>
        <Spin />
      </SpinWrapper>
    </LoadingDefaultHeight>
  );

  return (
      
    root?.render(
  
      <Suspense fallback={suspense}>

        <BrowserRouter>
          <SkeletonTheme
            baseColor       = {darkTheme.card__primary}
            highlightColor  = {darkTheme.skeleton__highlight}
          >
            <ITDProvider theme="dark">
              <PopBottomSheetProvider>
                <PrivateSocketProvider>
                  <PublicSocketProvider>
                    <WebProvider>
                      <App />
                    </WebProvider>
                  </PublicSocketProvider>
                </PrivateSocketProvider>
              </PopBottomSheetProvider>
            </ITDProvider>
          </SkeletonTheme>
        </BrowserRouter>

      </Suspense>

    )

  )

}

renderDOM();